import React from "react";
import s from "./InvestmentStrategy.module.scss";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";
import { useTranslation } from "react-i18next";

const InvestmentStrategy = () => {
  const { width } = useWindowDimensions();
  const { t } = useTranslation();
  return (
    <div>
      {width > 970 ? <Header /> : <MobileHeader />}
      <div className={s.content}>
        <h2 className={s.title}>{t("Инвестиционная стратегия")}</h2>
        <div className={s.text}>
          <div className={s.strong}>
            {t(
              "Инвестиционная стратегия предполагает формулирование общего уровня риск-аппетита на уровне Фонда и его каскадирование в конкретные ограничения для портфеля и отдельных инвестиций"
            )}{" "}
          </div>
          <div className={s.strong} style={{ marginTop: "30px" }}>
            {t(
              "Риск-аппетит как видение в части управления рисками на уровне Фонда"
            )}
          </div>
          {t(
            "Качественное формулирование основных принципов инвестирования и приемлемого уровня риска для Фонда"
          )}
          <div className={s.strong}>{t("Риск-аппетит на уровне портфеля")}</div>
          {t(
            "Каскадирование допустимого уровня риска на уровне портфеля (управлениерисками концентрации)"
          )}
          <div className={s.strong}>
            {t("Риск-аппетит на уровне отдельной сделки")}
          </div>
          {t(
            "Каскадирование допустимого уровня риска на уровне отдельной сделки и операционного управления"
          )}
        </div>
      </div>
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default InvestmentStrategy;
